import React from 'react'

const SvgComponent = props => (
  <svg width={77} height={77} {...props}>
    <defs>
      <linearGradient
        x1="-.056%"
        y1="49.997%"
        x2="100.003%"
        y2="49.997%"
        id="findfriend__prefix__a"
      >
        <stop stopColor="#B375B1" offset="0%" />
        <stop stopColor="#E03E5E" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="100%"
        y1="50%"
        x2="0%"
        y2="50%"
        id="findfriend__prefix__b"
      >
        <stop stopColor="#F7E0E0" offset="0%" />
        <stop stopColor="#FFF" offset="100%" />
      </linearGradient>
      <linearGradient
        x1=".017%"
        y1="49.913%"
        x2="99.851%"
        y2="49.913%"
        id="findfriend__prefix__c"
      >
        <stop stopColor="#B375B1" offset="0%" />
        <stop stopColor="#E03E5E" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="120.769%"
        y1="59.788%"
        x2="0%"
        y2="50%"
        id="findfriend__prefix__d"
      >
        <stop stopColor="#F7E0E0" offset="0%" />
        <stop stopColor="#FFF" offset="100%" />
      </linearGradient>
    </defs>
    <g fillRule="nonzero" fill="none">
      <g>
        <rect
          fill="url(#findfriend__prefix__a)"
          width={77}
          height={77}
          rx={20}
        />
        <path
          d="M55.92 48.275c2.786-4.15 4.86-8.792 4.86-13.87 0-12.343-9.993-22.336-22.335-22.336-12.341 0-22.335 9.993-22.335 22.335 0 6.007 2.84 11.468 6.335 16.165 3.167 4.26 6.826 8.464 10.758 12.014 1.802 1.584 3.058 2.567 5.188 2.567 2.457 0 4.04-1.584 5.788-3.113l-.655.655a89.314 89.314 0 0 0 11.523-13.325 4.05 4.05 0 0 0 .874-1.092z"
          fill="url(#findfriend__prefix__b)"
        />
        <circle
          fill="url(#findfriend__prefix__c)"
          cx={38.5}
          cy={34.131}
          r={15.291}
        />
        <path
          d="M28.834 39.374l-3.277 3.222c3.386 4.095 6.772 7.754 10.213 10.813 2.13 1.91 2.402 1.91 2.948 1.91.656 0 1.475-.654 2.73-1.692l.11-.164 3.222-3.276-9.557-10.65c-1.693-1.802-4.587-1.91-6.389-.163z"
          fill="url(#findfriend__prefix__d)"
        />
      </g>
      <path
        d="M52 42.286l-3.239-3.194c-1.451-1.456-3.797-1.456-5.304 0L41 41.502 46.919 48c1.507-1.569 3.685-4.034 5.081-5.714z"
        fill="url(#findfriend__prefix__d)"
      />
    </g>
  </svg>
)

export default SvgComponent
